import styled from 'styled-components';

const Wrapper = styled.div`
  height: 70px;
  margin-top: 40px;
  text-align: center;
`;

export default Wrapper;
